import { Navigate, Outlet } from "react-router-dom";
import { isInstitutionAdminWithInstitution } from "../auth/auth";

/**
 * Restricts institution-management pages to a provisioned Institution Admin
 * with a valid InstitutionId claim. Global admins have their own admin
 * workspace and should not enter institution-scoped pages without an
 * institution context.
 */
export default function InstitutionAdminRoute() {
  if (!isInstitutionAdminWithInstitution()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
